import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as CrossIcon } from 'assets/icons/times.svg';

import { ERROR, SUCCESS } from './types';
import useKeyPress from 'hooks/useKeyPress';

const Modal = ({
  isOpen,
  onConfirm,
  onCancel,
  type,
  title,
  message,
  cta,
  cta2,
  ctaClassName,
  hasIcon,
}) => {
  const [_isOpen, setIsOpen] = useState(isOpen);
  const enter = useKeyPress('Enter');
  const escape = useKeyPress('Escape');

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (escape) {
      onCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [escape]);

  useEffect(() => {
    if (enter) {
      onConfirm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enter]);

  return _isOpen ? (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center">
        <div
          className="fixed inset-0 bg-black bg-opacity-30 transition-opacity"
          aria-hidden="true"
        ></div>

        <div className="flex flex-col items-center mx-auto mt-40  w-full align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all max-w-lg py-12">
          <div className="bg-white px-4 pb-12">
            <div className="flex items-start">
              {hasIcon && (
                <div
                  className={`mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full md:mx-0 md:h-10 md:w-10 ${
                    type === ERROR ? 'bg-red-100' : 'bg-green-100'
                  }`}
                >
                  {type === SUCCESS && (
                    <CheckIcon className="text-green-600 fill-current w-6 h-4" />
                  )}
                  {type === ERROR && (
                    <CrossIcon className="text-red-600 fill-current w-4 h-4" />
                  )}
                </div>
              )}
              <div className="text-center">
                <h2
                  className="text-lg font-bold text-javelin-gray-dark"
                  id="modal-title"
                >
                  {title}
                </h2>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">{message}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex flex-row justify-center">
            {cta2 && (
              <button
                data-testid="cta2-button"
                type="button"
                className="btn h-12 w-48 font-bold bg-javelin-gray-light mr-6"
                onClick={onCancel}
              >
                {cta2}
              </button>
            )}
            {cta && (
              <button
                data-testid="cta-button"
                type="button"
                className={`btn h-12 w-48 ${ctaClassName}`}
                onClick={onConfirm}
              >
                {cta}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  type: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  cta: PropTypes.string,
  cta2: PropTypes.string,
  ctaClassName: PropTypes.string,
  hasIcon: PropTypes.bool,
};
Modal.defaultProps = {
  isOpen: false,
  type: ERROR,
  title: '',
  message: '',
  cta: 'OK',
  cta2: 'Close',
  hasIcon: false,
  ctaClassName: 'btn-primary',
};
export default Modal;
